export interface TranslatedText {
  en: string;
  lv: string;
  it: string;
}

export interface ChecklistItem {
  requirement: TranslatedText;
  required: TranslatedText;
  details: TranslatedText;
  description: TranslatedText;
}

export interface ChecklistSubsection {
  title: TranslatedText;
  description?: TranslatedText;
  items: ChecklistItem[];
}

export interface ChecklistSectionConfig {
  id: string;
  gradient: string;
  hoverBg: string;
  title: TranslatedText;
  tagline: TranslatedText;
  subsections: ChecklistSubsection[];
}

// Full trilingual shorthand
export const t = (en: string, lv: string, it: string): TranslatedText => ({
  en,
  lv,
  it,
});

// English-only shorthand (lv/it mirrored until translated)
export const te = (en: string): TranslatedText => ({ en, lv: en, it: en });

// Shared badge level translations
export const REQUIRED = t("Required", "Nepieciešams", "Obbligatorio");
export const RECOMMENDED = t("Recommended", "Ieteicams", "Consigliato");
export const OPTIONAL = t("Optional", "Neobligāts", "Facoltativo");
